import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 27px;
  padding: 4.5rem 8rem;
  min-height: 100vh;
  background-color: var(--primary-dark-50);

  // Align items to center on large screens
  @media (min-width: 1920px) {
    align-items: center;
  }
`;

export const DashboardSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
`;

export const DashboardTitle = styled.h1`
  display: flex;
  flex-direction: column;
  gap: 15px;
  font-size: var(--fs-lg);
  font-weight: 600;
`;

export const HelloMessageContainer = styled.div`
  display: flex;
  font-weight: 400;
  font-size: var(--fs-lg);
  color: var(--primary-blue);
  gap: 13px;
  max-width: 570px;
`;

export const HelloMessageEmoji = styled.article`
  font-size: 39px;
`;

export const HelloMessageText = styled.article`
  font-size: var(--fs-lg);
  font-style: italic;
  line-height: 28px;
`;
